import { storefrontGqlClient } from "./client"

export const query = async (query: string, variables?: any) => {
    const response = await storefrontGqlClient.post("/", {
        query,
        variables,
    });
    return response.data;
}
